import React from "react";

import { Container, Modal, Button } from "react-bootstrap";

import { FaTrashAlt } from "react-icons/fa";
import { deleteClient } from "../../../controllers/ControllerClient";

export default function DeleteClientModal(props) {
  const {
    showDeleteClientModal,
    setShowDeleteClientModal,
    getData,
    code3c_id,
  } = props;

  function clearFields() {
    setShowDeleteClientModal(false);
  }

  function handleClose() {
    setShowDeleteClientModal(!showDeleteClientModal);
  }

  async function handleDeleteClient() {
    const response = await deleteClient(
      showDeleteClientModal.name,
      showDeleteClientModal.id,
    );
    if (response) {
      getData(code3c_id);
      clearFields();
    }
  }

  return (
    <Container className="ubuntuFont">
      <Modal
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        className="ubuntuFont"
        show={showDeleteClientModal.show}
        onHide={handleClose}
        centered
      >
        <Modal.Header className="text-center" closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center"
          >
            <FaTrashAlt className="text-danger" />
            &emsp;Apagar Produtor?
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          Tem certeza que quer apagar o cliente:&nbsp;
          {showDeleteClientModal.name}?
          <Container className="my-3">
            <Button
              variant="danger"
              className="mr-2"
              onClick={() => handleDeleteClient()}
              style={{ width: "120px" }}
            >
              Apagar
            </Button>
            <Button
              variant="dark"
              onClick={() => handleClose()}
              style={{ width: "120px" }}
            >
              Cancelar
            </Button>
          </Container>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
